import { z } from 'zod';

const anonymousDuplicateAssetConflictSchema = z
  .object({ error: z.literal('duplicate_asset') })
  .strict();

const visibleDuplicateAssetConflictSchema = z
  .object({
    error: z.literal('duplicate_asset'),
    assetId: z.string().min(1),
    projectId: z.string().min(1),
    projectName: z.string().min(1),
  })
  .strict();

/** A global immutable-content match. Project details are present only when the backend authorizes
 * the current user to see the existing asset. The anonymous variant deliberately carries no IDs. */
export const duplicateAssetConflictSchema = z.union([
  visibleDuplicateAssetConflictSchema,
  anonymousDuplicateAssetConflictSchema,
]);

export type DuplicateAssetConflict =
  | { error: 'duplicate_asset'; assetId: string; projectId: string; projectName: string }
  | { error: 'duplicate_asset' };

export function duplicateAssetProjectName(conflict: DuplicateAssetConflict): string | undefined {
  return 'projectName' in conflict ? conflict.projectName : undefined;
}
